export const PUSH_TOAST = '@@toast/PUSH_TOAST'
export const SHIFT_TOAST = '@@toast/SHIFT_TOAST'

type toastStyle = 'warning' | 'error' | undefined

export interface Toast {
	title: string;
	body: string;
	style?: toastStyle;
}

export interface ToastState {
	toasts: Toast[];
	timeout: number;
}

interface ShowToastAction {
	type: typeof PUSH_TOAST;
	payload: Toast;
}

interface HideToastAction {
	type: typeof SHIFT_TOAST;
}

export type ToastActionTypes = ShowToastAction | HideToastAction
